import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TimeLogsComponent } from '../time-logs/time-logs.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { ToastrService } from 'ngx-toastr';
import { ExportTimeLogsComponent } from '../export-time-logs/export-time-logs.component';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss']
})
export class AuthorizationComponent implements OnInit {
  usrcde = '';
  usrpwd = '';
  auth_module = '';
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  openModal(): void {
    if (this.auth_module === 'TimeLogs') {
      const modalRef = this.modalService.open(TimeLogsComponent, { size: 'lg' });
    }
    else {
      const modalRef = this.modalService.open(ExportTimeLogsComponent, { size: 'lg' });
    }
  }

  async validate(): Promise<void> {
    if (this.usrcde === '' || this.usrpwd === '') {
      this.toastr.error('Please fill all fields');

      return;
    }
    this.spinner.show();
    const result = await this.daytranService.validateSupervisor({ usrcde: this.usrcde, usrpwd: this.usrpwd });
    await this.spinner.hide();
    if (result.success === 1) {
      this.toastr.success('Authorized');
      this.close();
      this.openModal();
    } else {
      this.toastr.error('Unauthorized');
      this.close();
    }
  }

  close() {
    this.activeModal.close();
  }

}
